export default __webpack_public_path__ + "static/media/_DSC0372.477308d6.JPG";